export function normalizeBaseUrl(url: string): string {
  return (url || '').replace(/\/+$/, '');
}

export function joinUrl(base: string, ...paths: string[]): string {
  const normalizedBase = normalizeBaseUrl(base);
  const suffix = paths
    .filter(path => path != null && path !== '')
    .map(path => path.replace(/^\/+|\/+$/g, ''))
    .join('/');

  return suffix ? `${normalizedBase}/${suffix}` : normalizedBase;
}
